import React, { useState, useEffect } from 'react'

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isVisible, setIsVisible] = useState(false)

  const heroSlides = [
    {
      image: '/newafrica.jpg',
      title: 'Our solutions reflect',
      highlight1: "Africa's perspective",
      middle: 'while meeting',
      highlight2: 'global standards'
    },
    {
      image: '/3d-illustration-robot-humanoid-looking-forward-against-cityscape-skyline.jpg',
      title: 'We promote',
      highlight1: 'sustainable practices',
      middle: 'through',
      highlight2: 'eco-friendly and ESG-driven solutions'
    },
    {
      image: '/cityscape.jpg',
      title: 'We pride ourselves on a ',
      highlight1: 'technologically-driven',
      middle: 'organisational system',
      highlight2: ''
    },
    {
      image: '/virtual-reality-finger-woman-home-night-online-games-entertainment-metaverse-technology-apartment-happy-person-with-vr-goggles-ai-experience-cyber-network-streaming.jpg',
      title: 'The path to impact | ',
      highlight1: '',
      middle: '',
      highlight2: 'Reimagined'
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true)
          }
        })
      },
      { threshold: 0.1 }
    )

    const section = document.getElementById('who-are-we-section')
    if (section) {
      observer.observe(section)
    }

    return () => {
      if (section) {
        observer.unobserve(section)
      }
    }
  }, [])

  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

  const services = [
    {
      title: 'Provision of expertise across the entire lifecycle of Africa',
      description: 'We support infrastructure development across sectors in African markets, ensuring sustainable growth and innovation.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      )
    },
    {
      title: 'Deep-rooted Advisory and market insights across industries',
      description: 'Our expertise spans multiple sectors, providing comprehensive advisory services tailored to market dynamics.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      title: 'Enhancement of services delivery through ESG solutions',
      description: 'We integrate environmental, social, and governance principles to enhance value and sustainability.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: 'Acquisition of deep technical knowledge of Africa',
      description: 'Years of experience have given us unparalleled insights into African markets and opportunities.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    }
  ]

  const milestones = [
    { number: '15+', label: 'Years of Experience' },
    { number: '1', label: 'Year in Business' },
    { number: '100%', label: 'Client Satisfaction' },
    { number: 'UHNIs', label: 'Renowned Clients' }
  ]

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Carousel - Improved mobile responsiveness */}
      <div className="relative h-[70vh] sm:h-[80vh] md:h-screen overflow-hidden">
        {/* Slides */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-transform duration-1000 ease-in-out ${
              index === currentSlide
                ? 'translate-x-0'
                : index < currentSlide
                ? '-translate-x-full'
                : 'translate-x-full'
            }`}
          >
            <div className="h-full relative bg-black">
              {/* Image - using img tag for better control on mobile */}
              <img 
                src={slide.image} 
                alt={`${slide.title}`}
                className={`absolute inset-0 w-full h-full object-cover ${
                  slide.image === '/newafrica.jpg' || slide.image === '/3d-illustration-robot-humanoid-looking-forward-against-cityscape-skyline.jpg'
                    ? 'md:object-center' 
                    : 'object-center'
                }`}
                style={
                  slide.image === '/newafrica.jpg' 
                    ? { objectPosition: '90% center' }
                    : slide.image === '/3d-illustration-robot-humanoid-looking-forward-against-cityscape-skyline.jpg'
                    ? { objectPosition: '38% center' }
                    : {}
                }
              />
              
              {/* Stronger overlay for better text readability on mobile */}
              <div className="absolute inset-0 bg-black bg-opacity-70 md:bg-opacity-60"></div>

              {/* Content */}
              <div className="relative z-10 h-full flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full md:ml-[4%] lg:mt-[15%]">
                  <div className="max-w-3xl">
                    <h1 className="font-inter text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-4xl font-medium text-white mb-4 sm:mb-6 tracking-wide leading-tight">
                      {slide.title} <span className="text-yellow-400">{slide.highlight1}</span>{' '}
                      {slide.middle} <span className="text-yellow-400">{slide.highlight2}</span>
                    </h1>
                    <a href="/services">
                      <button className="font-inter px-6 sm:px-8 py-2.5 sm:py-3 mt-4 sm:mt-8 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300 mt-14">
                        Learn More
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Dots */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-yellow-400 w-6 sm:w-8'
                  : 'bg-white bg-opacity-50 hover:bg-opacity-75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={() => goToSlide((currentSlide - 1 + heroSlides.length) % heroSlides.length)}
          className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 z-20 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all duration-300"
          aria-label="Previous slide"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={() => goToSlide((currentSlide + 1) % heroSlides.length)}
          className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 z-20 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 sm:p-3 rounded-full transition-all duration-300"
          aria-label="Next slide"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Services Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 bg-white">
        <div className="mb-8 sm:mb-12">
          <p className="font-inter text-sm text-gray-600 uppercase tracking-wider mb-4">OUR FOCUS</p>
          <h2 className="font-inter text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            We provide integrated, lifecycle solutions across the property consultancy value chain
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div key={index} className="font-inter bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center text-white mb-4">
                {service.icon}
              </div>
              <h3 className="text-base font-semibold font-inter text-gray-900 mb-3 leading-snug">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Enhanced Who Are We Section */}
      <div id="who-are-we-section" className="relative bg-gradient-to-br from-slate-50 via-white to-slate-50 py-16 sm:py-24 overflow-hidden">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400 rounded-full filter blur-3xl opacity-5 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-900 rounded-full filter blur-3xl opacity-5 animate-pulse delay-1000"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <p className="font-inter text-sm text-yellow-600 uppercase tracking-wider mb-3 font-semibold">
              Our Story
            </p>
            <h2 className="font-inter text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Who Are We?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto rounded-full"></div>
          </div>

          {/* Today Section - Separate Grid */}
          <div className={`mb-12 sm:mb-16 transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 xl:gap-12 items-center">
              {/* Text Content - Left Side on desktop, bottom on mobile/tablet */}
              <div className="xl:col-span-7 order-2 xl:order-1">
                <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border-l-4 border-blue-500 hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-inter text-2xl sm:text-3xl font-bold text-gray-900 mb-4"></h4>
                      <p className="font-inter text-gray-700 leading-relaxed mb-4">
                        Ofanda Africa delivers strategic advisory, valuation, research, and housing solutions, while exploring emerging areas like PropTech and Green Building Initiatives. In less than a year of business commencement, Ofanda Africa has provided advisory on iconic assets and served renowned Ultra High-net Worth Individuals (UHNIs) and organisations in the various sectors (including but not limited to financial services, hospitality, energy & power, electric mobility, amongst others). <br /><br /> <br />

                        Ofanda Africa stands out to provide you with a personalised experience and daring to raise the bar of your expectations.
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>

              {/* Image - Right Side */}
              <div className="xl:col-span-5 order-1 xl:order-2">
                <div className="relative rounded-2xl overflow-hidden shadow-xl group hover:shadow-2xl transition-shadow duration-500 max-w-md mx-auto xl:max-w-none">
                  <img 
                    src="1_20251023_102853_0000.svg" 
                    alt="Ofanda Africa Today" 
                    className=""
                    style={{ objectPosition: 'center 20%' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-transparent to-transparent opacity-40"></div>
                  
                  {/* Decorative overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-blue-900 to-transparent">
                    <p className="font-inter text-white text-lg font-bold">Building Africa's Future</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <p className="font-inter text-sm text-yellow-600 uppercase tracking-wider mb-3 font-semibold">
              Our Origin Story
            </p>
            <h2 className="font-inter text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our Origin
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto rounded-full"></div>
          </div>
          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            {/* CEO Card */}
            <div className={`lg:col-span-5 transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}>
              <div className="sticky top-8">
                <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden group hover:shadow-2xl transition-shadow duration-500">
                  {/* Decorative corner accent */}
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-yellow-400 to-transparent opacity-20 rounded-bl-full"></div>
                  
                  {/* Image Container */}
                  <div className="relative overflow-hidden">
                    <img 
                      src="mrtope.jpg" 
                      alt="Mr Babatope Fasunloro" 
                      className="w-full h-80 sm:h-96 object-cover object-center transform group-hover:scale-105 transition-transform duration-700"
                      style={{ objectPosition: 'center 20%' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60"></div>
                    
                    {/* CEO Label on Image */}
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white font-inter">
                      <div className="inline-block px-4 py-1.5 bg-yellow-400 text-gray-900 text-xs font-bold uppercase tracking-wider rounded-full mb-3">
                        Chief Executive Officer
                      </div>
                      <h3 className="font-inter text-2xl sm:text-3xl font-bold">
                        Mr Babatope Fasunloro
                      </h3>
                    </div>
                  </div>

                  {/* Achievement Highlights */}
                  <div className="p-6 bg-gradient-to-br from-blue-900 to-blue-950">
                    <div className="grid grid-cols-2 gap-4">
                      {milestones.map((milestone, index) => (
                        <div key={index} className="text-center">
                          <div className="text-2xl sm:text-3xl font-bold text-yellow-400 mb-1">
                            {milestone.number}
                          </div>
                          <div className="text-xs sm:text-sm text-gray-300 font-medium">
                            {milestone.label}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Story Content */}
            <div className={`lg:col-span-7 transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}>
              <div className="space-y-6">
                {/* Vision Statement */}
                <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border-l-4 border-blue-900 hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-inter text-xl font-bold text-gray-900 mb-3">The Vision</h4>
                      <p className="font-inter text-gray-700 leading-relaxed">
                        The story began from an early age of the Chief Promoter, having deep love for Africa and desiring to make a revolution in the property sector. While peers considered leaving for opportunities abroad, his love for the continent made him see territories with untapped potentials around its challenges.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Journey Section */}
                <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border-l-4 border-blue-900 hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-inter text-xl font-bold text-gray-900 mb-3">The Journey</h4>
                      <p className="font-inter text-gray-700 leading-relaxed mb-4">
                        So, he got to work, and for over fifteen years, gained professional experience spanning across valuation and advisory, property market research, and negotiation deals. During this time, his exposure to global standards further broadened his perspective, and he began to see opportunities focused on improving the existing local systems in the built environment.
                      </p>
                      <p className="font-inter text-gray-700 leading-relaxed italic">
                        As St. Augustine said, "our souls are restless until they find rest in God". But in this case, the founder's soul was restless until he found God's purpose concerning his career.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Birth of Ofanda */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                        </svg>
                      </div>
                    </div>
                    <div>
                      <h4 className="font-inter text-xl font-bold text-gray-900 mb-3">Birth of Ofanda</h4>
                      <p className="font-inter text-gray-700 leading-relaxed mb-4">
                        This is exactly why Ofanda was born. From the onset, the founder's vision had been to build a Property Consulting brand that could be trusted and measured by world-class standards; and thus, making the mission simple - to always keep to high professional standards and act with integrity at all times.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className={`mt-12 sm:mt-16 text-center transition-all duration-1000 delay-600 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="inline-flex flex-col sm:flex-row gap-4">
              <a href="/about">
                <button className="font-inter px-8 py-3 bg-blue-900 text-white font-semibold rounded-lg hover:bg-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                  Learn More About Us
                </button>
              </a>
              <a href="/contact">
                <button className="font-inter px-8 py-3 bg-yellow-400 text-gray-900 font-semibold rounded-lg hover:bg-yellow-500 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                  Schedule a Consultation
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-12 sm:py-16">
        <div className="rounded-2xl p-8 sm:p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-32 h-32 sm:w-40 sm:h-40 border-4 border-white rounded-full -translate-x-20 sm:-translate-x-28 translate-y-8 sm:translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-32 h-32 sm:w-40 sm:h-40 border-4 border-white rounded-full translate-x-20 sm:translate-x-28 -translate-y-8 sm:-translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 sm:mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="w-full sm:w-auto px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="w-full sm:w-auto px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home




